import { Smile } from "lucide-react";

// Rotating circular text stamp with a smiley in the middle.
const Stamp = ({ size = 120, className = "", bg = "bg-lime", text = "FIGHT FOR YOURSELF · FIGHT FOR YOURSELF · " }) => {
  const id = "stamp-path-" + text.length;
  return (
    <div
      className={`relative ${className}`}
      style={{ width: size, height: size }}
      data-testid="brand-stamp"
      aria-hidden="true"
    >
      <div className={`absolute inset-0 rounded-full ${bg} border border-ink animate-spin-slow`}>
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <defs>
            <path id={id} d="M 50,50 m -37,0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />
          </defs>
          <text className="display fill-ink" fontSize="9.5" letterSpacing="0.5">
            <textPath href={`#${id}`}>{text}</textPath>
          </text>
        </svg>
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <Smile className="text-ink" strokeWidth={2} style={{ width: size * 0.44, height: size * 0.44 }} />
      </div>
    </div>
  );
};

export default Stamp;
